import Vue from "vue";
import Vuex from "vuex";
import '../mixins.js';
import {get} from "axios";

Vue.use(Vuex)
var domain = "https://user.sigmafolio.net/"
export default new Vuex.Store({
    state: {

        //AD = asset detail
        AD_securityData: {
            securityType: null,
            securityName: null,
            securityIsin: null,
        },
        //portfolio dashboard
        PD_userData: [],
        PD_userPortfolio: null,
        PD_fetchUserData: null,
        accessToken: localStorage.getItem('access-token') || '',
        refreshToken: localStorage.getItem('refresh-token') || '',
        LP_activeTab: 0,
        //user portfolios
        UP_portfolios: [],
        //shared portfolios
        SP_portfolioData: []
    },
    getters: {
        get_AD_securityData: state => {
            return state.AD_securityData
        },
        get_PD_userData: state => {
            return state.PD_userData
        },
        get_PD_userPortfolio: state =>{
            return state.PD_userPortfolio
        },
        // authentication tokens
        get_access_token: state => {
            return state.accessToken
        },
        get_refresh_token: state => {
            return state.refreshToken
        },
        get_LP_activeTab: state => {
            return state.LP_activeTab
        },
        get_UP_portfolios: state => {
            return state.UP_portfolios
        },
        get_SP_portfolioData: state => {
            return state.SP_portfolioData
        }
    },
    mutations: {
        set_AD_securityData: (state, payload) => {
            if(payload[0] == 'stock'){
                state.AD_securityData.securityType = 'Aktie' 
            }
            else if(payload[0] == 'etf'){
                state.AD_securityData.securityType = 'ETF'  
            }
            else{
                state.AD_securityData.securityType = payload[0];
            }
            
            state.AD_securityData.securityName = payload[1];
            state.AD_securityData.securityIsin = payload[2];
        },
        set_PD_userData: (state, payload) => {
            state.PD_userData = payload;
        },
        set_PD_userPortfolio: (state, payload) => {
            state.PD_userPortfolio = payload;
        },
        set_PD_fetchPromise: (state, payload) => {
            state.PD_fetchUserData = payload;
        },
        set_LP_activeTab: (state, payload) => {
            state.LP_activeTab = payload
        },
        set_UP_portfolios: (state, payload) => {
            state.UP_portfolios = payload
        },
        set_SP_portfolioData: (state, payload) => {
            state.SP_portfolioData = payload;
        },
    },
    actions: {
        add_AD_securityData({ commit }, payload){
            commit('set_AD_securityData', payload);
        },
        change_LP_activeTab({commit}, payload){
            commit('set_LP_activeTab', payload)
        },
        async load_PD_userData({/*state,*/commit}, portfolio_id){
            commit('set_PD_userData', [])
            await get(domain +'portfolioDashboard/?format=json&portfolio_id=' + portfolio_id,{
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                        }
              })
                .then(response => {
                    console.log(response.data)
                    commit('set_PD_userData', response.data)
                }).catch(err => {
                    console.log(err)
                })
            
        
        },

        async update_PD_userData({commit}, portfolio_id){
            let promise = get(domain + 'portfolioDashboard/?format=json&portfolio_id='  + portfolio_id,{
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                        }
              })
            .then(response => {
                commit('set_PD_userData', response.data)
            }).catch(err => {
                console.log(err)
            })

            commit('set_PD_fetchPromise', promise);
            return promise;
        },

        async load_UP_portfolios({commit, state}){
            if(state.UP_portfolios.length == 0){
                await get(domain + 'overview/?format=json',{
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                        }
                })
                .then(response => {
                    commit('set_UP_portfolios', response);
                }).catch(err => {
                    console.log(err)
                })
                
                
            }

            
        },
        async load_SP_portfolioData({commit}, id, tokenValid){
            commit('set_SP_portfolioData', []);
            if(tokenValid == true){
                await get(domain + 'sharedPortfolioDashboard/?format=json&id=' + id,{
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                              }
                    })
                    .then(response => {
                        console.log(response)
                        commit('set_SP_portfolioData', response.data);
                    }).catch(err => {
                        console.log(err)
                    })               
            }else{
                await get(domain + 'sharedPortfolioDashboard/?format=json&id=' + id,{
                })
                .then(response => {
                    console.log(response)
                    commit('set_SP_portfolioData', response.data);
                }).catch(err => {
                    console.log(err)
                })
            }

        }
            
    }
}) 